
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .popup-date-range.q-ma-md
    .q-title.q-mb-md(v-if="params.title") {{params.title}}

    .flex.justify-center.items-end.q-mb-lg
      q-field
        SelectDate(
          :value="begin_date"
          @change="begin_date = arguments[0]"
        )

      .q-mx-sm 〜

      q-field
        SelectDate(
          :value="end_date"
          @change="end_date = arguments[0]"
        )

    .row.reverse.reverse-wrap
      q-btn.q-mx-sm(
        flat
        v-close-overlay
      ) キャンセル

      q-btn.q-mx-sm(
        flat
        color="primary"
        @click="confirm"
      ) 確定

      slot(:params="params")

</template>

<script>
import {isValid} from 'date-fns/esm'

import {dateToObject, dateToString, isEqualOrBefore, isEqualOrAfter} from 'helpers/date'

import SelectDate from 'components/SelectDate'

export default {
  components: {SelectDate},

  props: {
    max: String,
    min: String,
  },

  data() {
    return {
      visible:    false,

      ouie: {wow: 123},
      begin_date: null,
      end_date:   null,
      params:     {},
    }
  },

  watch: {
    begin_date(value) {
      const date = dateToObject(value)
      const subject = dateToObject(this.end_date)
      if(isValid(date) && isValid(subject) && isEqualOrAfter(date, subject)) {
        this.end_date = dateToString(date)
      }
    },

    end_date(value) {
      const date = dateToObject(value)
      const subject = dateToObject(this.begin_date)
      if(isValid(date) && isValid(subject) && isEqualOrBefore(date, subject)) {
        this.begin_date = dateToString(date)
      }
    },
  },

  methods: {
    show(date, params) {
      this.begin_date = date
      this.end_date   = date
      this.params     = params

      this.visible = true
    },

    hide() {
      this.visible = false
    },

    confirm() {
      // バリデーション

      this.$emit('confirm', this.begin_date, this.end_date, this.params)
    },
  },
}
</script>

<style lang="sass">
.popup-date-range
  width: 280px
</style>
